export default __webpack_public_path__ + "static/media/T4E.e0053830.png";